import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Users who attempted a given mock-test paper (with score + status).
const GetTestUsers = async ({ payload }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("test_code", payload.test_code);
  if (payload.course_url) data.append("course_url", payload.course_url);

  const res = await axios.post(ENDPOINT + "admin-get-test-users.php", data, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetTestUsers;
